import { initI18n } from '~/utils/i18n'

import { RemoteNamespace } from './remote'

export const { i18n: globalI18n, addTranslations: globalAddTranslations } =
  initI18n({
    remoteNamespaces: [
      RemoteNamespace.Log,
      RemoteNamespace.Metrics,
      RemoteNamespace.MetricsCompare
    ],
    remoteLazyLoad: true,
    useHttpBackend: true
  })
